import { render, staticRenderFns } from "./ListArticle.vue?vue&type=template&id=f992b0fe"
import script from "./ListArticle.ts?vue&type=script&lang=ts&external"
export * from "./ListArticle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports